import { LoggerAdapter } from './types';

const createConsoleLoggerAdapter = (): LoggerAdapter => ({
    log(...args) {
        this.info(...args);
    },

    info(...args) {
        if (global.console !== undefined) {
            global.console.info(...args);
        }
    },

    warn(...args) {
        if (global.console !== undefined) {
            global.console.warn(...args);
        }
    },

    error(...args) {
        if (global.console !== undefined) {
            global.console.error(...args);
        }
    },
});

export default createConsoleLoggerAdapter;
